import { ErrorHandler, Injectable, inject } from '@angular/core';
import { PosthogService } from '../services/posthog.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  private postHogService = inject(PosthogService);

  handleError(error: unknown): void {
    const err = error as { message?: string };
    if (err.message) {
      console.log(err.message);
    }
    this.postHogService.captureError(error).then(() => {
      console.error(error);
    });
  }
}
